<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Send a Broadcast Message</h4>
      <div class="col-md-6 offset-md-3 border p-4">
        <form>
          <div class="form-group mb-4">
            <div>
              <label>Please Select Message Receiver Category</label>
              <select
                class="form-control"
                v-model="receiver"
                required
                @change="getReceipients()"
              >
                <option selected disabled>Please Select Receivers Category</option>
                <option value="teachers">Teachers</option>
                <option value="students">Students</option>
                <option value="students/guardians">Guardians</option>
              </select>
            </div>
          </div>
          <div class="form-group mb-4" v-if="receiver && receiver != ''">
            <div>
              <label
                >Select specific receipients</label>

              <input class="form-control" placeHolder="Search..." @input="searchStudents()" v-model="searchKey">  
              <select class="form-control" v-model="receipients" multiple>
                <option
                  v-for="(receipent, index) in fetchedReceipients"
                  :key="index"
                  :value="receipent._id"
                >
                  {{ receipent.name }},
                  {{ receipent.first_name }} {{ receipent.last_name }},
                  {{ receipent.username }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group mb-4">
            <div>
              <label>Enter Broadcast Message Below</label>
              <textarea class="form-control" v-model="message" required></textarea>
            </div>
          </div>
          <div class="form-group">
            <div>
              <button type="button" @click="sendMessage()" class="btn btn-info btn-block">
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "BroadcastAdmin",
  components: {},
  data() {
    return {
      fastAdminToken: localStorage.getItem("fastAdminToken"),
      receiver: "",
      message: "",
      searchKey: "",
      receipients: [],
      allStudents: [],
      fetchedReceipients: [],
    };
  },
  methods: {
    sendMessage() {
      // eslint-disable-next-line no-console
      // console.log(this.receipients);

      if (this.receipients.length == 0) {
        this.$toast.open({
          message: "Error : Please select a user",
          type: "error",
        });
        return;
      }

      if (this.receiver != "" && this.receiver != null) {
        let receiver = this.receiver;

        let data = {
          message: this.message,
        };
        if (this.receipients.length > 0 && this.receiver == "teachers") {
          data.teachers = this.receipients;
        }
        if (
          this.receipients.length > 0 &&
          (this.receiver == "students" || this.receiver == "students/guardians")
        ) {
          data.students = this.receipients;
        }

        const config = {
          headers: {
            Authorization: "Bearer " + this.fastAdminToken,
            "Content-Type": "application/json",
          },
        };
        this.$toast.open({
          message: "Processing : Sending Message Please Wait...",
          type: "info",
        });
        axios
          .post(this.$apiURI + "/notify/" + receiver, data, config)

          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Broadcast Message Sent Successfully",
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });
      } else {
        this.$toast.open({
          message: "Error : Please select a receiver",
          type: "error",
        });
      }
    },

    getReceipients() {
      this.receiver != "" && this.receiver != null
        ? this.receiver == "teachers"
          ? this.getTeachers()
          : this.receiver == "students" || this.receiver == "students/guardians"
          ? this.getStudents()
          : alert("error geting receipients")
        : alert("error geting receipients");
    },

    getStudents() {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + "/account/students", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.teachers)
            this.allStudents = response.data.data.students;
            this.fetchedReceipients = []; 
            for (var i in this.allStudents) {
              this.fetchedReceipients.push(this.allStudents[i]);
            }
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },

    getTeachers() {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + "/account/teachers", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.teachers)
            this.allStudents = response.data.data.teachers;
            this.fetchedReceipients = []; 
            for (var i in this.allStudents) {
              this.fetchedReceipients.push(this.allStudents[i]);
            }
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },

    searchStudents() {
      this.fetchedReceipients = [];
      this.receipients = [];
      for (var i in this.allStudents) {
        if (`${this.allStudents[i].name}, ${this.allStudents[i].first_name} ${this.allStudents[i].last_name}, ${this.allStudents[i].username}`.toLowerCase().includes(
          this.searchKey.toLowerCase()
        ) ) {
          this.fetchedReceipients.push(this.allStudents[i]);
        }
      }
    }
  },
};
</script>
